module.exports = __webpack_public_path__ + "img/mob3.e453d605.png";